var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinBuyAmountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 666.7 666.7",
    style: {
      enableBackground: "new 0 0 666.7 666.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000103250251422812319690000005569955700991280279_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Q3_icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M633.3,666.7L633.3,666.7c-18.4,0-33.3-14.9-33.3-33.3V66.7H66.7v566.7c0,18.4-14.9,33.3-33.3,33.3l0,0 C14.9,666.7,0,651.7,0,633.3v-600C0,14.9,14.9,0,33.3,0h600c18.4,0,33.3,14.9,33.3,33.3v600C666.7,651.7,651.7,666.7,633.3,666.7 z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.3,
    cy: 633.3,
    r: 33.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.3,
    cy: 633.3,
    r: 33.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.3,
    cy: 633.3,
    r: 33.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.3,
    cy: 633.3,
    r: 33.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.3,
    cy: 633.3,
    r: 33.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,425l100,98.3c11.8,12.9,31.9,13.7,44.7,1.9c0.7-0.6,1.3-1.3,1.9-1.9l100-98.3c11.9-12.2,13.3-31.2,3.3-45 c-9.8-14.5-29.4-18.4-43.9-8.6c-2.2,1.5-4.3,3.3-6.1,5.3L366.7,420V166.7c0-18.4-14.9-33.3-33.3-33.3 c-18.4,0-33.3,14.9-33.3,33.3V420l-43.3-43.3c-11.6-13.1-31.6-14.3-44.7-2.7c-2,1.8-3.8,3.8-5.3,6.1 C196.7,393.8,198.1,412.8,210,425z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinBuyAmountIcon);
export default __webpack_public_path__ + "static/media/min_buy_amount_icon.e1a6a59ef1a940af41e3ed51e44c4e1f.svg";
export { ForwardRef as ReactComponent };